import HomePageBuilder from "@material-symbols/svg-500/rounded/laptop_mac.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const HomePageBuilderIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: HomePageBuilder });
	return <Icon />;
};

export default memo(HomePageBuilderIcon);
